import { TagIcon } from "app/components/Icons";
import Pill from "app/components/Pill";
import CustomTooltip from "app/components/Tooltip";
import CommonTagSelection from "app/containers/Features/components/CommonTagSelection";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTagList } from "app/redux/selector";
import { actions } from "../containers/Tickets/redux/slice";
import { ITag } from "../types";

const TagsButton: React.FC = () => {
  const dispatch = useDispatch();
  const tagList = useSelector(selectTagList);
   const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const handleSelectionChange = (updatedSelectedItems) => {
    console.log("Updated selected items:", updatedSelectedItems);
    setSelectedItems(updatedSelectedItems);
    dispatch(actions.setTicketFormValue({ name: 'tags', value: updatedSelectedItems }));
  };

  return (
    <>
      <CommonTagSelection
        options={tagList}
        selectedTags={selectedItems}
        onTagsChange={(tagIds) => {
          handleSelectionChange(tagIds);
        }}
        trigger={
          <button className="flex flex-row items-center justify-center h-[28px] min-w-[28px] rounded-[4px] border border-[#E9ECF2] hover:bg-[#ECEEF2] hover:text-[#79808A] hover:border-[#E9ECF2] transition-all duration-200">
           <CustomTooltip text="Set tags" position="bottom">
            <div className="flex items-center gap-1">
            <TagIcon />
            {selectedItems.length > 0 && (
              <span className="text-sm text-gray-700 bg-gray-200 px-1 py-1rounded">
                {selectedItems.length} tag
              </span>
            )}
          </div>
          </CustomTooltip>
          </button>
        }
        isHeader="Tags"
      />
    </>
  );
};

export default TagsButton;
